/**
 * Valor monetário vindo da API, como NÚMERO.
 *
 * O `cPay` serializa `Decimal` do Prisma como STRING (`price: '397'`, `'33.33'`), e em
 * JavaScript `+` com string é concatenação, não soma. Foi assim que o seletor de parcelas
 * mostrou **R$ 39.700,00** numa assinatura de R$ 397,00 (01/10/2026): a expressão somava dois
 * zeros ao preço — `'397' + 0 + 0 === '39700'`. O resumo ao lado mostrava R$ 397,00 porque
 * passava o mesmo valor direto para a divisão, onde o JavaScript converte.
 *
 * O defeito só aparece quando o preço serializa SEM casas decimais: `'397.00' + 0 + 0` vira
 * `'397.0000'`, que `Number` lê como 397 — por isso passou despercebido.
 *
 * Use em TODA aritmética com valor que veio da API. Formatar não precisa (o `Intl` converte).
 */
export const toAmount = (value: unknown): number => {
    const n = typeof value === 'number' ? value : Number(value ?? 0);
    return Number.isFinite(n) ? n : 0;
};
